
import React from "react";
import { 
  CloudRain, 
  Cloud, 
  Sun, 
  Smile, 
  Stars 
} from "lucide-react";
import { cn } from "@/lib/utils";

interface MoodRatingProps {
  value: string;
  label: string;
  selected: boolean;
  onSelect: (value: string) => void;
  disabled?: boolean;
}

export function MoodRating({ 
  value, 
  label, 
  selected, 
  onSelect,
  disabled = false
}: MoodRatingProps) {
  const icons = {
    "1": CloudRain,
    "2": Cloud,
    "3": Sun,
    "4": Smile,
    "5": Stars
  };
  
  const Icon = icons[value as keyof typeof icons] || Sun;
  
  const handleClick = () => {
    if (!disabled) {
      onSelect(value);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        "flex flex-1 flex-col items-center py-2 px-1 rounded-lg border transition-all",
        selected 
          ? "bg-blue-900/30 border-blue-700 text-blue-100" 
          : "bg-slate-900/30 border-slate-800 text-slate-300 hover:border-slate-700",
        disabled && "opacity-50 cursor-not-allowed"
      )}
      disabled={disabled}
    >
      <Icon className={cn(
        "w-6 h-6 mb-1",
        selected && "text-blue-400"
      )} />
      <span className="text-xs">{label}</span>
    </button>
  );
}
